/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCreditDto } from '../../models/backend-credit-dto';

export interface FinancingSourcesCreditsList$Params {
  /**
   * * `0` - Дифференцируемый
   * * `1` - Аннуитетный
   */
  calculation_type?: 0 | 1;
  capex?: number;
  capitalization?: boolean;
  create_date?: string;
  date?: string;
  date_in?: string;
  grace_period_interest?: number;
  grace_period_principal?: number;
  interest_rate?: number;
  is_blocked?: boolean;
  lender?: string;
  name?: string;
  sum_in_currancy?: number;
  tenor?: number;
  variant?: number;
}

export function financingSourcesCreditsList(
  http: HttpClient,
  rootUrl: string,
  params?: FinancingSourcesCreditsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendCreditDto>>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesCreditsList.PATH, 'get');
  if (params) {
    rb.query('calculation_type', params.calculation_type, {});
    rb.query('capex', params.capex, {});
    rb.query('capitalization', params.capitalization, {});
    rb.query('create_date', params.create_date, {});
    rb.query('date', params.date, {});
    rb.query('date_in', params.date_in, {});
    rb.query('grace_period_interest', params.grace_period_interest, {});
    rb.query('grace_period_principal', params.grace_period_principal, {});
    rb.query('interest_rate', params.interest_rate, {});
    rb.query('is_blocked', params.is_blocked, {});
    rb.query('lender', params.lender, {});
    rb.query('name', params.name, {});
    rb.query('sum_in_currancy', params.sum_in_currancy, {});
    rb.query('tenor', params.tenor, {});
    rb.query('variant', params.variant, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendCreditDto>>;
    }),
  );
}

financingSourcesCreditsList.PATH = '/api/financing_sources/credits/';
